export default class run_time {
    private _intervalIdList: number[] = [];
    private _timeoutIdList: number[] = [];

    _setInterval(callback: Function, delay: number) {
        var id = setInterval(callback, delay);
        this._intervalIdList.push(id);
        return id;
    }

    _setTimeout(callback: Function, delay: number) {
        var id = setTimeout(callback, delay);
        this._timeoutIdList.push(id);
        return id;
    }

    _clearTimeTickers() {
        for (var i = 0; i < this._intervalIdList.length; i++) {
            clearInterval(this._intervalIdList[i]);
        }
        for (var i = 0; i < this._timeoutIdList.length; i++) {
            clearTimeout(this._timeoutIdList[i]);
        }
        this._intervalIdList = [];
        this._timeoutIdList = [];
    }

    _clearTimeOutList() {
        for (var i = 0; i < this._timeoutIdList.length; i++) {
            clearTimeout(this._timeoutIdList[i]);
        }
        this._timeoutIdList = [];
    }
    _clearintervalList() {
        for (var i = 0; i < this._intervalIdList.length; i++) {
            clearInterval(this._intervalIdList[i]);
        }
        this._intervalIdList = [];
    }
}
